import { ContactBuyerProps } from 'views/Refund/components/ContactBuyer';
import { DefaultButton } from './DefaultButton';
import { ReactComponent as ContactFill } from 'views/Refund/assets/contact-fill.svg';
import { useMutation } from '@tanstack/react-query';
import useModal from 'hooks/useModal';
import ConversationModal from 'views/Setting/Remind/components/ConversationModal';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useCallback } from 'react';
import { getTalkInfoByBuyerStore } from 'services/api/refund';
import { useContactBuyer } from 'views/Refund/components/useContactBuyer';

interface ContactProps extends Omit<ContactBuyerProps, 'children'> {
  platform: General.PlatformUpperCase;
  disabled?: boolean;
}

export const Contact = (props: ContactProps) => {
  const {
    platform,
    disabled = false,
    buyerNick,
    region,
    externalStoreId,
    externalBuyerId,
    orderSn,
    type,
    returnSn,
    reverseOrderId,
  } = props;
  const { t } = useTranslate();
  const { meta, visible, show, hide } = useModal<Conversation.Conversation>();

  const trigger = useContactBuyer();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: () => {
      return getTalkInfoByBuyerStore({
        items: [
          {
            region,
            channel: platform,
            externalStoreId,
            externalBuyerId,
          },
        ],
      });
    },
  });

  const handleClick = useCallback(async () => {
    try {
      const { talkInfos } = await mutateAsync();
      const conversation = talkInfos?.[0];
      const res = await trigger({
        orderSn,
        region,
        externalBuyerId,
        externalStoreId,
        buyerNick,
        returnSn,
        reverseOrderId,
        type,
        channel: platform,
        conversation,
      });
      if (!res) {
        return;
      }
      show(res);
    } catch (err) {
      message.error(t('errorMsg.会话不存在'));
    }
  }, [
    buyerNick,
    externalBuyerId,
    externalStoreId,
    mutateAsync,
    orderSn,
    platform,
    region,
    returnSn,
    reverseOrderId,
    show,
    t,
    trigger,
    type,
  ]);

  return (
    <>
      <DefaultButton
        loading={isLoading}
        className="!flex !items-center !gap-1"
        icon={<ContactFill className="w-[20px] h-[20px]" />}
        onClick={handleClick}
        disabled={disabled}
      >
        {buyerNick}
      </DefaultButton>
      {meta && (
        <ConversationModal
          destroyOnClose
          forceAcquireControlReason="PROCESS_REFUND_OR_RETURN"
          record={meta}
          visible={visible}
          onCancel={() => {
            hide();
          }}
        />
      )}
    </>
  );
};
